// Single source of truth for "does this asset currently behave as STS?".
//
// Free-choice and custom assets keep `assetType: 'free'` forever — the mode
// the talent actually works in lives in `session.freeMode[idx]`. Every
// consumer that dispatches TTS vs. STS (sidebar status, export snapshot,
// upload summary) must use THIS check; checking `assetType === 'sts'` alone
// silently treats free/custom assets in STS mode as TTS (audit 2026-07-17,
// UploadSummary finding).

export type AssetTypeTag = 'tts' | 'sts' | 'free';

export function isStsMode(
  assetType: AssetTypeTag | undefined,
  freeMode: 'tts' | 'sts' | undefined,
): boolean {
  return assetType === 'sts' || (assetType === 'free' && freeMode === 'sts');
}
